/* Cart page layout script. Moved from the Custom Liquid section at the top of templates/cart.json so browsers can cache it (6 Oct 2026). */

(function() {
  function mccCartLayout() {
    var mainContent = document.getElementById('MainContent');
    var cartFooter = document.querySelector('[id*="__cart-footer"]');
    if (!mainContent) return;

    /* --- Empty cart detection --- */
    var cartItems = document.querySelector('cart-items');
    var hasItems = false;
    if (cartItems) {
      /* Check for actual product rows (not empty state divs) */
      var rows = cartItems.querySelectorAll('tr[id^="CartItem-"]');
      hasItems = rows.length > 0;
    }

    if (hasItems) {
      mainContent.classList.remove('mcc-cart-empty');
    } else {
      mainContent.classList.add('mcc-cart-empty');
    }

    /* --- DOM-move full-width sections (desktop only) --- */
    if (window.innerWidth < 990) return;
    if (!cartFooter) return;

    var selectors = [
      '[id*="__mcc_recently_viewed"]',
      '[id*="__featured-collection"]',
      '[id*="__trust_badges"]'
    ];

    selectors.forEach(function(sel, idx) {
      var el = cartFooter.querySelector(sel) || mainContent.querySelector(sel);
      if (!el) return;

      /* Move to MainContent if not already a direct child */
      if (el.parentNode !== mainContent) {
        mainContent.appendChild(el);
      }

      el.style.gridArea = String(3 + idx) + ' / 1 / auto / -1';
    });
  }

  /* Robust boot: retry until sections exist in DOM, then move them */
  function mccBoot() {
    if (window.innerWidth < 990) return;
    var footer = document.querySelector('[id*="__cart-footer"]');
    var rv = footer && footer.querySelector('[id*="__mcc_recently_viewed"]');
    if (rv) {
      mccCartLayout();
    } else if (document.readyState === 'complete') {
      /* Sections not yet in DOM after load — poll briefly */
      var attempts = 0;
      var poll = setInterval(function() {
        attempts++;
        var f = document.querySelector('[id*="__cart-footer"]');
        var r = f && f.querySelector('[id*="__mcc_recently_viewed"]');
        if (r || attempts > 20) {
          clearInterval(poll);
          if (r) mccCartLayout();
        }
      }, 200);
    }
  }
  if (document.readyState === 'complete') {
    mccBoot();
  } else {
    window.addEventListener('load', function() { setTimeout(mccBoot, 100); });
  }

  /* Re-run when cart items change (add/remove) */
  document.addEventListener('DOMContentLoaded', function() {
    var cartEl = document.querySelector('[id*="__cart-items"]');
    if (cartEl) {
      new MutationObserver(function() {
        setTimeout(mccCartLayout, 200);
      }).observe(cartEl, {childList: true, subtree: true});
    }
  });

  /* Expose for reRenderCartItems hook */
  window.mccFixCartSpacing = mccCartLayout;
})();


  /* --- Reveal below-cart sections after page layout is stable --- */
  function mccRevealBelowCart() {
    var targets = document.querySelectorAll('[id*="__mcc_recently_viewed"], [id*="__featured-collection"], [id*="__trust_badges"]');
    targets.forEach(function(el) { el.classList.add('mcc-revealed'); });
  }
  /* Wait for window.load (all resources including images loaded) then reveal.
     This ensures the cart table is fully rendered with images, so the
     below-cart sections are already below the fold when they fade in. */
  window.addEventListener('load', function() {
    requestAnimationFrame(mccRevealBelowCart);
  });
  /* Safety: if load already fired (e.g. script runs late), reveal immediately */
  if (document.readyState === 'complete') {
    requestAnimationFrame(mccRevealBelowCart);
  }
